import "./NewsList.scss";
import NewsEditDialog from "@/components/News/NewsEditDialog/NewsEditDialog.vue";
import NewsFilter from "@/components/News/NewsFilter/NewsFilter.vue";
import NewsExportPopup from "@/components/News/NewsExportPopup/NewsExportPopup.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import {
  destroyFile,
  forceFileDownload,
  getMongoFileId,
  getTokenHeader,
  getPrincipalName,
  getThumbnailUrl
} from "@/helpers/commonHelper";
import * as newsHelper from "@/helpers/newsHelper";
let newsHelperVar = { ...newsHelper };
delete newsHelperVar["imports"];
import { imports } from "@/helpers/newsHelper";
import * as newsGbXmlHelper from "@/helpers/newsGbXmlHelper";
import axios from "axios";
import _, { orderBy } from "lodash";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import * as XLSX from "xlsx";
import { sortByCategory } from "@/helpers/newsGbXmlHelper";

import { stringifyUTF8 } from "@/helpers/eventHelper";
import ColumnVisibilitySelector from "@/components/Common/ColumnVisibilitySelector/ColumnVisibilitySelector.vue";
import NewsAppPushMessagesNotification from "@/views/News/NewsAppPushMessagesNotification/NewsAppPushMessagesNotification.vue";
import BatchRewriteDialog from "@/components/News/BatchRewriteDialog/BatchRewriteDialog.vue";
import BatchAssignChannelDialog from "@/components/News/BatchAssignChannelDialog/BatchAssignChannelDialog.vue";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "NewsList",
  components: {
    NewsAppPushMessagesNotification,
    ColumnVisibilitySelector,
    NewsEditDialog,
    NewsFilter,
    NewsExportPopup,
    BatchRewriteDialog,
    BatchAssignChannelDialog
  },
  props: ["update"],
  data() {
    return {
      headers: [
        {
          text: "Vorschaubild",
          align: "start",
          value: "image",
          sortable: false
        },
        {
          text: "Import",
          align: "start",
          value: "import",
          sortable: false
        },
        { text: "Titel", value: "title", width: "35%" },
        {
          text: "Merkmale",
          align: "start",
          value: "feature",
          width: "15%"
        },
        { text: "Geändert", value: "change_date" },
        { text: "Kanäle", value: "channels" },
        {
          text: "Artikel-Typ",
          value: "articleTypes"
        },
        {
          text: "Priorität",
          value: "priority"
        },
        {
          text: "Ausgabe",
          align: "start",
          value: "issue"
        },
        { text: "Status", value: "status", align: "center" },
        { text: "Geprüft", value: "release", align: "center" },
        { text: "Top-Nachricht", value: "highlight", align: "center" },
        {
          text: "Aktionen",
          value: "actions",
          sortable: false,
          align: "center",
          width: "15%"
        }
      ],
      config: {},
      foundPois: [],
      issues: {},
      features: [],
      featureGroups: [],
      appContentTypes: [],
      newsUser: [],
      search: "",
      filter: {
        issueId: "",
        creatorId: "",
        channels: "",
        featureIds: "",
        articleType: "",
        priority: "",
        deleted: false
      },
      editDialog: false,
      editedItem: {},
      previewDialog: false,
      previewData: {},
      defaultItem: {
        alternative_content: {
          web: "",
          gemeindeblatt: ""
        },
        newsDate: "",
        meta_data: {
          keywords: [],
          url_part: ""
        },
        feature_ids: [],
        related_news: [],
        channels: [],
        images: [],
        files: [],
        contactPersons: [],
        production_note: "",
        articleType: {},
        reviewStatus: {},
        title: "",
        principal_id: this.currentPrincipal,
        creator_id: "",
        change_date: "",
        create_date: "",
        priority: null,
        issue_id: "",
        released: false,
        content: "",
        web_release_date: new Date().toISOString(),
        highlight: false,
        isNew: true,
        _id: "",
        hideAdZones: false
      },
      news: [],
      availableNewsForAppPushMessage: [],
      ignoreFilter: false,
      loading: true,
      loadingOverlay: false,
      options: {},
      total: 0,
      mainPeacock: "#00636C",
      mainRed: "#c55c52",
      page: 1,
      pageCount: 0,
      statusItem: {},
      isMounted: false,
      isFetchingPois: false,
      toggleFilter: false,
      visibleColumnKeys: [
        "image",
        "import",
        "title",
        "feature",
        "change_date",
        "channels",
        "issue",
        "status",
        "release",
        "highlight",
        "actions",
        "articleType",
        "priority"
      ],
      exportType: "",
      xmlExportType: "legacy",
      exportPopupIsOpen: false,
      selected: [],
      allPagesSelected: false,
      batchDialogOpen: false,
      batchItems: [],
      batchExcludedLockedCount: 0,
      batchExcludedDeletedCount: 0,
      batchLoading: false,
      batchDeleteLoading: false,
      batchAssignDialogOpen: false,
      batchAssignItems: [],
      batchAssignLockedCount: 0,
      batchAssignDeletedCount: 0,
      batchAssignLoading: false,
      exportSortOptions: {
        primary: undefined,
        secondary: undefined,
        third: undefined,
        fourth: undefined
      },
      SELECTABLE_NEWS_EXPORT_SORT_OPTIONS: [
        {
          title: "Merkmalsgruppe (Sortierungswert)",
          id: "feature_group",
          default: true,
          sortBy: news => {
            const features = news.feature_ids.map(id =>
              this.features.find(_ => _._id === id)
            );
            const featureGroups = features.map(feature =>
              this.featureGroups.find(_ => _._id === feature?.feature_group_id)
            );
            const featureGroupsSort = featureGroups.map(
              featureGroup => featureGroup?.sort
            );
            const noFeatureGroupSortValue = 999;
            const sortValue = featureGroupsSort.reduce((acc, curr) => {
              if (isNaN(curr)) {
                return noFeatureGroupSortValue;
              }
              return Math.min(acc, curr);
            }, noFeatureGroupSortValue);
            return sortValue;
          }
        },
        {
          title: "Merkmale (Sortierungswert)",
          id: "features",
          sortBy: news => {
            const features = news.feature_ids
              .map(id => this.features.find(_ => _._id === id))
              .map(feature => feature?.sort)
              .filter(featureSort => !!featureSort);
            const noFeatureSortValue = 999;
            const sortValue = features.reduce((acc, curr) => {
              if (isNaN(curr)) {
                return noFeatureSortValue;
              }
              return Math.min(acc, curr);
            }, noFeatureSortValue);
            return sortValue;
          }
        },
        {
          title: "Datum der Nachricht",
          id: "newsDate",
          sortBy: news => {
            if (news.newsDate) {
              return new Date(news.newsDate);
            }
            return "";
          }
        },
        {
          title: "Top Nachricht",
          id: "highlight",
          sortBy: news => {
            if (news.highlight) {
              return 0;
            }
            return 1;
          }
        },
        {
          title: "Titel",
          id: "title",
          sortBy: news => {
            return news.title;
          }
        },
        {
          title: "Priorität",
          id: "priority",
          sortBy: news => {
            const noPrioritySortValue = 999;
            if (!news.priority?.length) {
              return noPrioritySortValue;
            }
            const priorityMapping = {
              niedrig: 2,
              mittel: 1,
              hoch: 0
            };
            return priorityMapping[news.priority];
          }
        }
      ]
    };
  },
  watch: {
    options() {
      if (this.isMounted) this.loadNews();
    },
    search(val) {
      if (val?.length >= 3) {
        this.clearSelection();
        this.loadNews();
      }
      if (val === "") {
        this.clearSelection();
        this.loadNews();
      }
    },
    async currentPrincipal() {
      this.clearSelection();
      this.filter = {
        issueId: "",
        creatorId: "",
        channels: "",
        featureIds: "",
        deleted: false,
        articleType: "",
        priority: ""
      };
      this.setFilterFromLocalStorage();
      await this.loadCollections();
      this.loadNews();
    },
    async editDialog(val) {
      if (val) {
        await this.fetchExistingAppPushMessageForNews();
      } else if (this.$refs.newsEditDialog) {
        this.$refs.newsEditDialog.existingAppPushMessage = null;
      }
    }
  },
  computed: {
    currentHeaders() {
      const selected = new Set(this.visibleColumnKeys);
      return this.headers.filter(header => selected.has(header.value));
    },
    columnOptions() {
      return this.headers.map(header => ({
        text: header.text || header.value,
        value: header.value
      }));
    },
    columnSettingsStorageKey() {
      return "news_columns";
    },
    allowedPoiTypes() {
      return this.$store.state.selectedPrincipal?.allowedPoiTypes || [];
    },

    poiCategoryTypes() {
      return this.$store.state.categoryTypes;
    },
    isPoiUser() {
      return (
        this.isAdmin ||
        this.currentUser?.scopes?.includes("role:poi") ||
        this.currentUser?.scopes?.includes("role:poi_admin") ||
        this.currentUser?.scopes?.includes("role:poi_edit")
      );
    },
    isKisPersonUser() {
      return (
        this.isAdmin ||
        this.currentUser?.scopes?.includes("role:kis") ||
        this.currentUser?.scopes?.includes("role:kis_admin") ||
        this.currentUser?.scopes?.includes("role:kis_persons")
      );
    },
    hasPoiModule() {
      // in case modules are completely populated
      const foundPOIModule = this.$store.state.selectedPrincipal?.modules?.find(
        m => m?._id === "628b5e26e06088f80f9dc96c"
      );
      // in case only module IDs are populated
      const includedPoiModule = this.$store.state.selectedPrincipal?.modules?.includes(
        "628b5e26e06088f80f9dc96c"
      );

      return foundPOIModule || includedPoiModule;
    },
    hasKisModule() {
      // in case modules are completely populated
      const foundKisModule = this.$store.state.selectedPrincipal?.modules?.find(
        m => m?._id === "662a42822dcdc9021cc2e515"
      );
      // in case only module IDs are populated
      const includedKisModule = this.$store.state.selectedPrincipal?.modules?.includes(
        "662a42822dcdc9021cc2e515"
      );

      return foundKisModule || includedKisModule;
    },
    personCount() {
      return this.$store.state.personCount;
    },
    persons() {
      return orderBy(this.$store.state.persons, "firstName");
    },
    articleTypes() {
      return this.$store.state.newsArticleTypes;
    },
    channels() {
      const ownChannels = this.$store.state.newsConfig?.own_channels ?? [];
      const standardChannels =
        this.$store.state.newsConfig?.standard_channels ?? [];
      const channels = this.$store.state.newsConfig?.channels ?? [];
      const activeOwnChannels = ownChannels.filter(channel =>
        channels.includes(channel.value)
      );
      const activeStandardChannels = standardChannels.filter(channel =>
        channels.includes(channel.value)
      );
      return activeStandardChannels.concat(activeOwnChannels);
    },
    currentPrincipal() {
      return this.$store.state?.selectedPrincipal?.id;
    },
    principals() {
      return this.$store.state.principals ?? [{}];
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return (
        this.currentUser?.scopes.includes("role:admin") ||
        this.currentUser?.scopes.includes("role:news_admin")
      );
    },
    userCanSendPushMessages() {
      return this.currentUser?.scopes.includes("role:news_app_push_messages");
    },
    newsEditor() {
      return this.currentUser?.scopes.includes("role:news_editor");
    },
    newsAdmin() {
      return this.currentUser?.scopes.includes("role:news_admin");
    },
    cFilterChanged() {
      const empty =
        !this.filter.channels &&
        !this.filter.creatorId &&
        !this.filter.featureIds &&
        !this.filter.issueId &&
        !this.filter.articleType &&
        !this.filter.priority;
      return !empty;
    },
    cIssues() {
      if (this.issues?.length)
        return this.issues?.map(item => {
          if (item.closed && !item.title.includes("(geschlossen)")) {
            item.title += " (geschlossen)";
          }
          return item;
        });
    },
    previewPrint() {
      return (
        this.previewData?.alternative_content?.gemeindeblatt ||
        this.previewData.content
      );
    },
    previewWeb() {
      return (
        this.previewData?.alternative_content?.web || this.previewData.content
      );
    },
    appdinxLogin() {
      return this.$store.state.selectedPrincipal?.additional_data?.appdinxLogin;
    },
    activeImports() {
      return imports
        .filter(_ => _.isActive(this.$store.state.selectedPrincipal))
        .map(_ => _.typeId);
    },
    isPaginationDisabled() {
      if (!(this.isPoiUser && this.hasPoiModule)) {
        return false;
      }
      return this.isFetchingPois;
    },
    promptsApiUrl() {
      return env.prompts_api_client_url;
    },
    newsApiUrl() {
      return env.news_api_client_url;
    },
    selectionLabel() {
      if (this.allPagesSelected) {
        return `Alle ${this.total} Nachrichten ausgewählt`;
      }
      return `${this.selected.length} von ${this.total} ausgewählt`;
    }
  },
  async mounted() {
    const itemsPerPage = 20;
    this.filter.itemsPerPage = this.filter.limit = itemsPerPage;
    await this.$store.dispatch("getNewsConfig");
    await this.$store.dispatch("getAllUsers");
    await this.$store.dispatch("getThirdPartySystems", { module: "News" });
    await this.loadArticleTypes();
    await this.loadCollections();
    this.setFilterFromLocalStorage();
    await this.loadNews();
    //this.update if route is: /anzeigenassistent/news/update/:id
    if (this.update) {
      await this.fetchNews(this.update);
    }

    if ((this.isAdmin || this.userCanSendPushMessages) && !!this.appdinxLogin) {
      this.$nextTick().then(() => {
        this.getAvailableNewsForAppPushMessage(
          this.$refs.newsAppPushMessagesNotification?.maxNumberOfSuggestions
        );
      });
    }

    if (this.isKisPersonUser && this.hasKisModule) {
      await this.getAllPersons();
    }

    if (this.isPoiUser && this.hasPoiModule) {
      await this.$store.dispatch("getCategoryTypes");
      await this.findPois();
    }

    this.isMounted = true;
  },
  methods: {
    getPrincipalName,
    getThumbnailUrl,
    normalizeArticleTypePayload(item) {
      const articleType = item?.articleType;
      const legacyArticleType = item?.articleTpye;
      const hasArticleTypeValues =
        articleType &&
        typeof articleType === "object" &&
        !Array.isArray(articleType) &&
        Object.keys(articleType).length > 0;
      const hasLegacyArticleTypeValues =
        legacyArticleType &&
        typeof legacyArticleType === "object" &&
        !Array.isArray(legacyArticleType) &&
        Object.keys(legacyArticleType).length > 0;

      if (!hasArticleTypeValues && hasLegacyArticleTypeValues) {
        item.articleType = cloneDeep(legacyArticleType);
      }

      return item;
    },
    async loadArticleTypes() {
      try {
        await this.$store.dispatch("getNewsArticleTypes", {
          principal_id: this.currentPrincipal
        });
      } catch (err) {
        this.$emit("createError", err);
      }
    },
    getNormalizedPriority(priority) {
      if (!priority?.length) return "-";

      // first letter uppercase, rest lowercase
      return priority.charAt(0).toUpperCase() + priority.slice(1).toLowerCase();
    },
    getArticleTypeName(itemArticleType) {
      if (!itemArticleType || typeof itemArticleType !== "object") {
        return "";
      }
      const articleTypeKey = Object.keys(itemArticleType || {})[0];
      const articleTypeId = itemArticleType[articleTypeKey];

      const articleType = this.articleTypes.find(
        type => type.value === articleTypeId
      );

      return articleType?.title || "";
    },
    async getAllPersons() {
      const limit = 100;
      await this.$store.dispatch("getPersons", {
        skip: this.persons.length,
        limit,
        getAll: true
      });
    },
    async nextPage() {
      if (this.page >= this.pageCount) return;
      this.page++;
      await this.loadNews();
    },
    async previousPage() {
      if (this.page === 1) return;
      this.page--;

      await this.loadNews();
    },
    ownChannels(channels) {
      const ownChannels = [];
      channels?.forEach(channel => {
        const foundChannel = this.config.own_channels.find(
          c => c.value === channel
        );
        if (foundChannel) ownChannels.push(foundChannel);
      });
      return ownChannels;
    },
    previewImage(item) {
      const url = item?.images?.[0]?.url;
      return this.getThumbnailUrl(url, "news", 70, "-");
    },
    morePictures(item) {
      return item.images.length > 1;
    },
    async loadCollections() {
      await this.loadConfig();
      await this.loadIssues();
      await this.loadFeatures();
      await this.loadFeatureGroups();
      await this.loadAppContentTypes();
      await this.getNewsUser(this.currentPrincipal);
    },

    async getNewsUser(principal) {
      const headers = getTokenHeader();
      if (headers) {
        const response = await axios.get(
          `${env.auth_api_client_url}users/find`,
          {
            params: {
              principal_id: principal
            },
            headers
          }
        );
        let users = response?.data.data ?? [];
        const selectedPrincipal = this.$store.state.selectedPrincipal;
        let principals = [selectedPrincipal?.id];

        if (selectedPrincipal.subPrincipals?.length)
          principals = principal.concat(selectedPrincipal.subPrincipals);

        users = users.filter(user => principals.includes(user.principal_id));

        users?.forEach(user => {
          user.name = `${user.first_name} ${user.last_name}`;
        });
        this.newsUser = users;
      }
    },

    async fetchNews(id) {
      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal
      };
      this.$refs.newsEditDialog.loadingStatus(true);
      try {
        const response = await axios.get(
          env.news_api_client_url + "news/" + id,
          {
            headers,
            params
          }
        );
        const fetchedItem = Object.assign({}, response.data);
        this.editedItem = this.normalizeArticleTypePayload(fetchedItem);
        this.$refs.newsEditDialog.fillData(this);
        this.editDialog = true;
      } catch (error) {
        this.close();
        this.createError(error);
      }
      this.$refs.newsEditDialog.loadingStatus(false);
    },
    setFilterFromLocalStorage() {
      if (localStorage?.newsFilter) {
        const newsFilter = JSON.parse(localStorage.newsFilter);
        this.filter = newsFilter[this.currentPrincipal] || this.filter;
      }
    },
    getNewsSearchParams(pagenation = true) {
      const { sortBy, sortDesc, itemsPerPage } = this.options;
      let sortByValue = sortBy?.[0] || "";
      switch (sortByValue) {
        case "feature":
          sortByValue = "print_category_sort";
          break;
        case "issue":
          sortByValue = "issue_sort";
          break;
        case "release":
          sortByValue = "released";
          break;
      }

      let params = {
        query: this.search,
        principal_id: this.currentPrincipal,
        limit: itemsPerPage,
        offset: (this.page - 1) * itemsPerPage,
        sort: sortByValue,
        direction: sortDesc?.[0] ? "desc" : "asc",
        issue_id: this.filter.issueId,
        creator_id: this.filter.creatorId,
        channels: this.filter.channels,
        feature_ids: this.filter.featureIds,
        deleted: this.filter.deleted,
        article_type: this.filter.articleType,
        priority: this.filter.priority
      };
      if (!pagenation) {
        // WARNING strange service behavior
        // if the limit is higher than the filtered items
        // the entries will be limited to 20
        params.limit = this.total;
        params.offset = 0;
      }
      //filter empty params
      Object.keys(params).forEach(
        key => params[key] === undefined && delete params[key]
      );
      return params;
    },
    saveNewsFilter() {
      let newsFilter = {};
      if (localStorage.newsFilter) {
        newsFilter = JSON.parse(localStorage.newsFilter) ?? {};
      }
      localStorage.newsFilter = JSON.stringify({
        ...newsFilter,
        [this.currentPrincipal]: this.filter
      });
    },
    async loadNews(pagenation = true) {
      if (!this.config) {
        return;
      }
      this.loading = true;
      const headers = getTokenHeader();
      const params = this.getNewsSearchParams(pagenation);
      this.saveNewsFilter();
      try {
        const response = await axios.get(env.news_api_client_url + "news", {
          headers,
          params
        });
        if (!pagenation) {
          // f.e. for export (xml, images, excel)
          this.loading = false;
          // news count changed -> cancel export + ask user to search again
          if (parseInt(response?.headers?.["x-count"]) !== this.total) {
            this.createError({
              text:
                "Bitte erneut suchen. Die Menge der Nachrichten hat sich verändert."
            });
            return [];
          }
          return response.data;
        }
        this.news = response.data;
        let count = response?.headers?.["x-count"];
        if (isNaN(count)) {
          console.error("no number in x-count");
        }
        this.total = parseInt(count);
      } catch (error) {
        this.createError(error);
      }
      this.loading = false;
    },
    async getAvailableNewsForAppPushMessage(limit) {
      this.availableNewsForAppPushMessage = null;

      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal
      };
      try {
        const response = await axios.get(
          env.news_api_client_url +
            "app_push_message/available-news" +
            (limit ? `?limit=${limit}` : ""),
          {
            params,
            headers
          }
        );
        this.availableNewsForAppPushMessage = response.data;
      } catch (error) {
        await this.createError(error);
        this.availableNewsForAppPushMessage = null;
      }
    },
    async fetchExistingAppPushMessageForNews() {
      if (this.editedItem.isNew || !this.editedItem._id) {
        this.$refs.newsEditDialog.existingAppPushMessage = null;
        return;
      }
      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal,
        news_id: this.editedItem._id
      };
      try {
        const res = await axios.get(
          env.news_api_client_url + "app_push_message",
          {
            headers,
            params
          }
        );
        if (res.data?.length) {
          this.$refs.newsEditDialog.existingAppPushMessage = res.data[0];
        } else {
          this.$refs.newsEditDialog.existingAppPushMessage = null;
        }
      } catch (e) {
        this.$refs.newsEditDialog.existingAppPushMessage = null;
        console.error(e);
      }
    },
    statusColor(item) {
      if (item.status === "green") {
        return this.mainPeacock;
      }
      if (item.status === "" || item.status === "none") {
        return "gray";
      }
      return item.status;
    },
    createItem() {
      this.$store.state.relatedNews = [];
      this.editedIndex = -1;
      this.defaultItem.channels = [...(this.config.default_channels ?? [])];
      this.editedItem = _.cloneDeep({ ...this.defaultItem });
      if (this.editedItem.channels.includes("app")) {
        this.editedItem.released = true;
      }
      this.editedItem.isNew = true;
      this.editedItem.principal_id = this.currentPrincipal;
      this.$refs.newsEditDialog.fillData(this);
      this.editDialog = true;
    },
    async editItem(item) {
      this.editedIndex = this.news.indexOf(item);
      const clonedItem = cloneDeep(item);
      this.editedItem = this.normalizeArticleTypePayload(clonedItem);
      this.editedItem.isNew = false;
      //prefill cached data
      this.$refs.newsEditDialog.fillData(this);
      this.editDialog = true;

      //refresh data
      this.fetchNews(item._id);
    },
    deleteItem(item) {
      this.$confirm(
        `Sind Sie sicher, dass Sie 
        <br>"${item.title}" löschen wollen?`,
        confirmWarningConfig
      ).then(async res => {
        if (res) {
          try {
            await this.deleteNews(item);
          } catch (err) {
            this.createError(err);
            return;
          }
          this.editedIndex = this.news.indexOf(item);
          this.editedItem = Object.assign({}, item);
          this.$refs.newsEditDialog.fillData(this);
          this.news.splice(this.editedIndex, 1);
          this.closeDelete();
        }
      });
    },
    async deleteNews(item) {
      const title = item.title;
      const params = {
        principal_id: this.currentPrincipal
      };
      const allFiles = item.files.concat(item.images);
      allFiles.asyncForEach(async file => {
        await destroyFile("news", getMongoFileId(file));
      });
      const headers = getTokenHeader(),
        res = await axios.delete(`${env.news_api_client_url}news/${item._id}`, {
          headers,
          params
        });
      if (res.status === 200) {
        this.createSuccess(title + " gelöscht!");
      } else {
        this.createError({ ...res, text: item.title + " nicht gelöscht!" });
      }
    },
    async findPois() {
      this.isFetchingPois = true;
      try {
        if (!this.allowedPoiTypes?.length) return;
        const query = {
          currentPrincipal: this.currentPrincipal,
          $limit: 100,
          $skip: 0,
          $sort: { title: 1 },
          $and: [[{ categoryType: { $in: this.allowedPoiTypes } }]],
          extended: true,
          backendSearch: true
        };

        const headers = getTokenHeader();
        const response = await axios.get(`${env.poi_api_client_url}poi/`, {
          params: { ...query },
          headers
        });
        this.foundPois = response.data?.data || [];
        const total = response.data?.total || 0;
        if (total > 100) {
          const pages = Math.ceil(total / 100);
          for (let page = 1; page < pages; page++) {
            const resp = await axios.get(`${env.poi_api_client_url}poi/`, {
              params: {
                ...query,
                $skip: page * 100
              },
              headers
            });
            this.foundPois = this.foundPois.concat(resp.data?.data || []);
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isFetchingPois = false;
      }
    },
    afterSave(close) {
      if (this.editedIndex > -1) {
        Object.assign(this.news[this.editedIndex], this.editedItem);
      } else {
        this.news.push(this.editedItem);
      }
      this.loadNews();

      const logOverviewRef = this.$refs.newsEditDialog?.$refs?.logOverview;
      const logsFetched = logOverviewRef?.logsFetched;
      logOverviewRef?.resetLogs();

      if (close) {
        this.close();
      } else if (logsFetched) {
        logOverviewRef?.getLogs().then(null);
      }

      this.createSuccess("Erfolgreich gespeichert!");

      if (
        (this.isAdmin || this.userCanSendPushMessages) &&
        !!this.appdinxLogin
      ) {
        this.$nextTick().then(() => {
          this.getAvailableNewsForAppPushMessage(
            this.$refs.newsAppPushMessagesNotification?.maxNumberOfSuggestions
          ).then(null);
        });
      }
    },
    detachNews(item) {
      this.$confirm(
        `<b>"${item.title}"</b> gehört zu einer geschlossenen Print-Ausgabe.
        Soll eine Kopie erstellt werden um die Nachricht für andere Kanäle (z.B. Web) zu bearbeiten?`,
        confirmWarningConfig
      ).then(async res => {
        if (res) {
          await this.detachNewsRequest(item); //except gemeindeblatt-channel
          this.copyNews({ ...item, channels: ["web"] }, this.isLocked(item));
        }
      });
    },
    close() {
      if (this.update) {
        this.$router.push("/news/news");
        this.editDialog = false;
        return;
      }
      this.editDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.$refs.newsEditDialog.fillData(this);
        this.$refs.newsEditDialog?.$refs?.logOverview?.resetLogs();
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.$refs.newsEditDialog.fillData(this);
        this.editedIndex = -1;
      });
    },
    statusOpen(item) {
      this.statusItem = Object.assign({}, item);
    },
    async detachNewsRequest(item) {
      item.loading = true;
      try {
        const headers = getTokenHeader();
        await axios.put(
          `${env.news_api_client_url}news/`,
          {
            id: item._id,
            _id: item._id,
            principal_id: item.principal_id,
            channels: ["gemeindeblatt"], //only gemeindeblatt-channel
            meta_data: {
              ...item.meta_data,
              url_part:
                item?.meta_data?.url_part?.split("_")[0] +
                "_" +
                (Date.now() + "").slice(-5) //rename url_part to avoid conflict
            },
            onlyUpdateToDetach: true
          },
          { headers }
        );
      } catch (err) {
        this.createError(err);
      }
      item.loading = false;
    },
    async updateStatus(item, sendItem) {
      item.loading = true;
      try {
        const headers = getTokenHeader();
        const res = await axios.put(
          `${env.news_api_client_url}news/`,
          {
            id: sendItem._id,
            _id: sendItem._id,
            principal_id: sendItem.principal_id,
            status: sendItem.status
          },
          { headers }
        );
        item.status = res.data.status;
      } catch (err) {
        this.createError(err);
      }
      item.loading = false;
    },
    async updateRelease(item) {
      if (!item.deleted) {
        if (item.released) {
          const res = await this.$confirm(
            "Geprüft wirklich zurücknehmen?",
            confirmWarningConfig
          );
          if (!res) {
            return;
          }
        }
        item.loading = true;
        try {
          const headers = getTokenHeader();
          const res = await axios.put(
            `${env.news_api_client_url}news/`,
            {
              id: item._id,
              _id: item._id,
              principal_id: item.principal_id,
              released: !item.released
            },
            { headers }
          );
          item.released = res.data.released;
        } catch (err) {
          this.createError(err);
        }
        item.loading = false;
      }
    },
    async updateNewsHighlight(item) {
      if (!item.deleted) {
        item.loading = true;
        try {
          const headers = getTokenHeader();
          const res = await axios.put(
            `${env.news_api_client_url}news/`,
            {
              id: item._id,
              _id: item._id,
              principal_id: item.principal_id,
              highlight: item.highlight
            },
            { headers }
          );
          item.highlight = res.data.highlight;
        } catch (err) {
          this.createError(err);
        }
        item.loading = false;
      }
    },
    copyNews(news, isLocked) {
      const clone = Object.assign({}, news);
      clone.web_release_date = new Date();
      delete clone.id;
      delete clone._id;
      clone._id = "";
      delete clone.newsDate;
      delete clone.web_expire_date;
      delete clone.web_archive_date;
      if (isLocked) {
        //remove closed issue
        delete clone.issue_id;
      }
      for (const key of Object.keys(clone)) {
        if (key.startsWith("appdinx")) {
          delete clone[key];
        }
      }
      clone.released = false;
      this.editedIndex = -1;
      this.editedItem = clone;
      this.editedItem.isNew = true;
      this.editedItem.principal_id = this.currentPrincipal;

      this.$refs.newsEditDialog.fillData(this);
      this.editDialog = true;
    },
    /**
     * return filename of given path
     * @param path
     * @return filename
     */
    basename(path) {
      return path.split("/").reverse()[0];
    },
    filterChanged() {
      this.clearSelection();
      this.loadNews();
    },
    selectAllPages() {
      this.allPagesSelected = true;
    },
    clearSelection() {
      this.selected = [];
      this.allPagesSelected = false;
    },
    async openBatchRewrite() {
      this.batchLoading = true;
      try {
        const eligible = this.allPagesSelected
          ? await this.loadNews(false)
          : this.selected;
        const items = eligible || [];
        this.batchItems = items.filter(
          item => !this.isLocked(item) && item.deleted !== true
        );
        this.batchExcludedDeletedCount = items.filter(
          item => item.deleted === true
        ).length;
        this.batchExcludedLockedCount = items.filter(
          item => item.deleted !== true && this.isLocked(item)
        ).length;
        this.batchDialogOpen = true;
      } finally {
        this.batchLoading = false;
      }
    },
    onBatchClose() {
      this.batchDialogOpen = false;
    },
    async openBatchAssignChannel() {
      this.batchAssignLoading = true;
      try {
        const eligible = this.allPagesSelected
          ? await this.loadNews(false)
          : this.selected;
        const items = eligible || [];
        this.batchAssignItems = items.filter(
          item => !this.isLocked(item) && item.deleted !== true
        );
        this.batchAssignDeletedCount = items.filter(
          item => item.deleted === true
        ).length;
        this.batchAssignLockedCount = items.filter(
          item => item.deleted !== true && this.isLocked(item)
        ).length;
        this.batchAssignDialogOpen = true;
      } finally {
        this.batchAssignLoading = false;
      }
    },
    onBatchAssignClose() {
      this.batchAssignDialogOpen = false;
    },
    async onBatchAssignSaved({ savedCount, items }) {
      (items || []).forEach(updated => {
        const idx = this.news.findIndex(n => n._id === updated._id);
        if (idx > -1) {
          Object.assign(this.news[idx], updated);
        }
      });
      this.clearSelection();
      if (savedCount) {
        this.createSuccess(
          `${savedCount} Nachricht${savedCount === 1 ? "" : "en"} aktualisiert`
        );
        await this.loadNews();
      }
    },
    async openBatchDelete() {
      this.batchDeleteLoading = true;
      try {
        const eligible = this.allPagesSelected
          ? await this.loadNews(false)
          : this.selected;
        const items = eligible || [];
        const deletable = items.filter(
          item =>
            item.deleted !== true && (this.isAdmin || !this.isLocked(item))
        );
        const deletedCount = items.filter(item => item.deleted === true).length;
        const lockedCount = items.filter(
          item => item.deleted !== true && !this.isAdmin && this.isLocked(item)
        ).length;

        if (!deletable.length) {
          this.createError({
            text: "Keine löschbare Nachricht in der Auswahl."
          });
          return;
        }

        let confirmText = `Sind Sie sicher, dass Sie ${
          deletable.length
        } Nachricht${deletable.length === 1 ? "" : "en"} löschen wollen?`;
        if (lockedCount) {
          confirmText += `<br>${lockedCount} Nachricht${
            lockedCount === 1 ? "" : "en"
          } in gesperrten Ausgaben ${
            lockedCount === 1 ? "bleibt" : "bleiben"
          } erhalten.`;
        }
        if (deletedCount) {
          confirmText += `<br>${deletedCount} Nachricht${
            deletedCount === 1 ? "" : "en"
          } ${deletedCount === 1 ? "ist" : "sind"} bereits gelöscht und ${
            deletedCount === 1 ? "wird" : "werden"
          } übersprungen.`;
        }

        const confirmed = await this.$confirm(
          confirmText,
          confirmWarningConfig
        );
        if (!confirmed) return;

        const deletedIds = [];
        let failedCount = 0;
        for (const item of deletable) {
          try {
            await this.deleteNewsSilently(item);
            deletedIds.push(item._id);
          } catch (err) {
            failedCount++;
            console.error(err);
          }
        }

        this.news = this.news.filter(n => !deletedIds.includes(n._id));
        this.total = Math.max(0, this.total - deletedIds.length);
        this.clearSelection();

        if (deletedIds.length) {
          this.createSuccess(
            `${deletedIds.length} Nachricht${
              deletedIds.length === 1 ? "" : "en"
            } gelöscht`
          );
        }
        if (failedCount) {
          this.createError({
            text: `${failedCount} Nachricht${
              failedCount === 1 ? "" : "en"
            } konnte${failedCount === 1 ? "" : "n"} nicht gelöscht werden.`
          });
        }
      } finally {
        this.batchDeleteLoading = false;
      }
    },
    async deleteNewsSilently(item) {
      const params = {
        principal_id: this.currentPrincipal
      };
      const allFiles = item.files.concat(item.images);
      allFiles.asyncForEach(async file => {
        await destroyFile("news", getMongoFileId(file));
      });
      const headers = getTokenHeader();
      await axios.delete(`${env.news_api_client_url}news/${item._id}`, {
        headers,
        params
      });
    },
    async onBatchSaved({ savedCount, items }) {
      (items || []).forEach(updated => {
        const idx = this.news.findIndex(n => n._id === updated._id);
        if (idx > -1) {
          Object.assign(this.news[idx], updated);
        }
      });
      this.clearSelection();
      if (savedCount) {
        this.createSuccess(
          `${savedCount} Nachricht${
            savedCount === 1 ? "" : "en"
          } mit KI-Korrektur gespeichert`
        );
        await this.loadNews();
      }
    },
    ...newsHelperVar,
    ...newsGbXmlHelper,
    async openPopup(exportType) {
      if (!(await this.acceptFilterWarning())) {
        return;
      }
      this.exportType = exportType;
      if (this.exportType === "image") {
        await this.downloadImageZip();
      } else {
        this.exportPopupIsOpen = true;
      }
    },
    async exportList() {
      this.loadingExport = true;

      switch (this.exportType) {
        case "xml":
          await this.downloadXml();
          break;
        case "xlsx":
          await this.downloadExcel();
          break;
      }

      this.loadingExport = false;
      this.exportPopupIsOpen = false;
    },
    async downloadXml() {
      if (this.xmlExportType === "web2print") {
        await this.downloadWeb2PrintXml();
        return;
      }

      await this.downloadLegacyXml();
    },
    async downloadLegacyXml() {
      await this.downloadXmlForConfiguredSort(this.buildLegacyIssueXml);
    },
    async downloadWeb2PrintXml() {
      await this.downloadXmlForConfiguredSort(this.buildWebToPrintIssueXml);
    },
    async downloadXmlForConfiguredSort(buildXmlFunction) {
      this.loadingOverlay = true;

      let news = await this.loadNews(false);
      const sortBy = Object.values(this.exportSortOptions)
        .filter(sortOption => !!sortOption)
        .map(sortOption => sortOption.sortBy);

      news = _.sortBy(news, sortBy);

      let xml = await buildXmlFunction.call(this, news, this.foundPois);
      forceFileDownload(xml, "gemeindeblatt.xml");

      this.loadingOverlay = false;
    },
    async downloadExcel() {
      this.loadingOverlay = true;

      // add title line
      const data = [
        [
          "ID",
          "Mandant",
          "Ausgabe",
          "Titel",
          "Kurztitel",
          "Merkmale",
          "Merkmalsgruppen",
          "Beschreibung",
          "Teaser",
          "Autor",
          "Link",
          "Nachrichten Links",
          "Verknüpfte Nachrichten",
          "Produktionshinweis",
          "Priorität",
          "Status",
          "Geprüft",
          "Top-Nachricht",
          "Gelöscht",
          "Kanäle",
          "Ersteller",
          "Erstellt",
          "Geändert",
          "Veröffentlichungsdatum Web",
          "Metadaten Keywords",
          "Metadaten Urlpart",
          "Metadaten Beschreibung",
          "Metadaten Alternativer Titel",
          "Appdinx Kanäle"
        ]
      ];

      const statusLabel = {
        ready: "Bereit zur Prüfung",
        edit: "In Bearbeitung"
      };

      const alternativeChannels = this.channels.filter(
        channel => channel.value !== "gemeindeblatt"
      );
      const indexAfterMainDescription = data[0].indexOf("Beschreibung") + 1;
      alternativeChannels.forEach((channel, index) => {
        data[0].splice(
          indexAfterMainDescription + index,
          0,
          `Alternativ-${channel.title}`
        );
      });

      let items = await this.loadNews(false);

      const sortBy = Object.values(this.exportSortOptions)
        .filter(sortOption => !!sortOption)
        .map(sortOption => sortOption.sortBy);

      items = _.sortBy(items, sortBy);

      items.forEach(news => {
        const dataHelper = [
          news._id,
          this.getPrincipalName(news.principal_id) ?? "",
          this.getIssueById(news.issue_id)?.title,
          news.title,
          news.short_title,
          this.getFeatureTitles(news),
          this.getFeatureGroupTitles(news),
          stringifyUTF8(
            [news.content, news.content_2, news.content_3]
              .filter(Boolean)
              .join("<br>")
          ).replace(/<[^>]*>/g, " ") ?? "",
          stringifyUTF8(news.teaser).replace(/<[^>]*>/g, " ") ?? "",
          news.author ?? "",
          news.news_link ?? "",
          this.getNewsLinks(news.news_links),
          this.getRelatedNewsTitles(news.related_news),
          news.production_note ?? "",
          news.priority ?? "-",
          statusLabel[news.status] ?? "-",
          news.released ? "Ja" : "Nein",
          news.highlight ? "Ja" : "Nein",
          news.deleted ? "Ja" : "Nein",
          this.getChannelTitles(news.channels) ?? "",
          this.getUserName(news.creator_id) ?? "",
          news.create_date?.toString().dateFormat(),
          news.change_date?.toString().dateFormat(),
          news.web_release_date?.toString().dateFormat(),
          news.meta_data?.keywords?.join(", ") ?? "",
          news.meta_data?.url_part ?? "",
          news.meta_data?.description ?? "",
          news.meta_data?.alternative_title ?? "",
          news.appdinx_channels?.join(", ") ?? ""
        ];
        alternativeChannels.forEach((channel, index) => {
          if (
            news?.alternative_content &&
            news?.alternative_content[channel.value]
          ) {
            const description = news.alternative_content[channel.value] ?? "";
            dataHelper.splice(
              indexAfterMainDescription + index,
              0,
              stringifyUTF8(description).replace(/<[^>]*>/g, " ") ?? ""
            );
          } else dataHelper.splice(indexAfterMainDescription + index, 0, "");
        });

        data.push(dataHelper);
      });

      // create XLSX file structure
      const ws = XLSX.utils.aoa_to_sheet(data);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, ws, "News");
      XLSX.writeFile(workbook, "nachrichten.xlsx");
      this.loadingOverlay = false;
    },
    getRelatedNewsTitles(rNews) {
      const mappedNews =
        rNews.map(news => this.news.find(n => n._id === news)?.title ?? "") ??
        [];
      return mappedNews.join(", ");
    },
    getChannelTitles(channels) {
      const mappedChannels =
        channels.map(
          channel => this.channels.find(ch => ch.value === channel)?.title ?? ""
        ) ?? [];
      return mappedChannels.join(", ");
    },
    getNewsLinks(newsLinks) {
      const mappedNewsLinks = newsLinks.map(link => link.url);
      return mappedNewsLinks.join(", ");
    },
    getUserName(user) {
      const foundUser = this.newsUser.find(item => item._id === user);
      if (foundUser) return `${foundUser.first_name} ${foundUser.last_name}`;
      return "";
    },
    async downloadImageZip() {
      this.loadingOverlay = true;
      const imgArray = [];
      const filesArray = [];
      let news = await this.loadNews(false);
      news = sortByCategory(news);
      const uniqueFilenames = [];
      const sameNameFiles = this.getSameNameFiles(news);

      news.forEach(item => {
        item.images.forEach((img, index) => {
          let filename = this.getFilename(img, ["jpg", "jpeg", "png"]);
          if (sameNameFiles.includes(filename)) {
            filename =
              (img._id || img.id || item._id + "_" + index.toString()) +
              "_" +
              filename;
          }
          img.filename = filename;
          imgArray.push(img);
        });

        item.files.forEach((file, index) => {
          let filename = this.getFilename(file, []);
          if (uniqueFilenames.includes(filename)) {
            filename =
              (file._id || file.id || item._id + "_" + index.toString()) +
              "_" +
              filename;
          }
          uniqueFilenames.push(filename);

          file.filename = filename;
          filesArray.push(file);
        });
      });

      try {
        const headers = getTokenHeader();
        const res = await axios.post(
          `${env.news_api_client_url}news/gemeindeBlattZip`,
          { images: imgArray, files: filesArray },
          {
            headers,
            responseType: "arraybuffer"
          }
        );
        forceFileDownload(res.data, "gemeindeblatt.zip");
      } catch (error) {
        this.createError(error);
      }
      this.loadingOverlay = false;
    },
    async acceptFilterWarning() {
      if (!this.filter.issueId) {
        const confirmRes = await this.$confirm(
          `Es wurde keine Ausgabe gefiltert/gewählt!<br>
                  Trotz dessen herunterladen?`,
          confirmWarningConfig
        );
        if (confirmRes) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    }
  }
};
